<template>
  <div class="turnOver-page">
    <div class="turnOver-flex-text">浏览器的缓存数据</div>
    <div class="turnOver-flex-button" @click="moreTap()">清理</div>
    <div class="turnOver-flex-text">微信授权</div>
    <div class="turnOver-flex-button" @click="wxTap()">{{isJsApi?'关闭':'开启'}}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isJsApi: true,
    };
  },
  created() {
    if (localStorage.isJsApi) {
      this.isJsApi = /true/g.test(localStorage.isJsApi);
    }
    typeof WeixinJSBridge !== 'undefined' && WeixinJSBridge.call('hideOptionMenu');
  },
  methods: {
    moreTap() {
      const _self = this;
      this.$api.Message('提示', '是否清空浏览器的缓存?').then((res) => {
        if (res) {
          _self.$api.showload('处理中');
          const date = new Date();
          date.setTime(date.getTime() - 10000);
          const cookieList = document.cookie.replace(/['" ]/g, '').split(';');
          cookieList.map((item) => {
            document.cookie = `${item.split('=')[0]}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
          });
          localStorage.clear();
          setTimeout(() => {
            _self.$api.hidload();
            _self.$api.Message('提示', '清除成功');
          }, 1000);
        }
      });
    },
    wxTap() {
      this.isJsApi = !this.isJsApi;
      localStorage.isJsApi = this.isJsApi;
    },
  },
};
</script>

<style lang="less">
.turnOver-page {
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;

  .turnOver-flex-text {
    width: 90%;
    margin-bottom: 0.2rem;
    padding: 0.5rem 2%;
    color: #999;
    margin-top: 3rem;
  }

  .turnOver-flex-button {
    width: 90%;
    background-color: #2590c8;
    color: #ffffff;
    padding: 1rem 2%;
    border-radius: 0.5rem;
    text-align: center;
  }
}
</style>
